import React, { useEffect, useState } from "react";
import { Box, Stack, Avatar, Paper } from "@mui/material";
import SparklesIcon from "@mui/icons-material/AutoAwesome";
import ShimmeringText from "./ShimmeringText";

const AILoader = () => {
  const [stage, setStage] = useState(0);

  useEffect(() => {
    const stage1 = setTimeout(() => setStage(1), 5000);
    const stage2 = setTimeout(() => setStage(2), 10000);
    return () => {
      clearTimeout(stage1);
      clearTimeout(stage2);
    };
  }, []);

  const getText = () => {
    if (stage === 0) return "Thinking...";
    if (stage === 1) return "Crafting a thoughtful response…";
    return "Still working on it… making sure it’s the best!";
  };

  return (
    <Stack direction="row" spacing={2} alignItems="flex-start" mb={3}>
      {/* Static Avatar + Animated Icon inside */}
      <Avatar
        sx={{
          bgcolor: "grey.900",
          width: 36,
          height: 36,
          fontSize: 14,
        }}
      >
        <Box
          sx={{
            animation: "iconRotateScale 1.8s ease-in-out infinite",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SparklesIcon fontSize="small" />
        </Box>
      </Avatar>

      {/* Loader Bubble */}
      <Paper
        elevation={1}
        sx={{
          p: 2,
          maxWidth: "100%",
          bgcolor: "#f5f5f5",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <ShimmeringText text={getText()} />
      </Paper>

      {/* Keyframes for Icon animation only */}
      <style>
        {`
          @keyframes iconRotateScale {
            0% {
              transform: scale(1) rotate(0deg);
            }
            25% {
              transform: scale(0.6) rotate(20deg);
            }
            50% {
              transform: scale(1) rotate(0deg);
            }
            75% {
              transform: scale(0.6) rotate(-20deg);
            }
            100% {
              transform: scale(1) rotate(0deg);
            }
          }
        `}
      </style>
    </Stack>
  );
};

export default AILoader;
